import PropTypes from "prop-types";

const propTypes = {
  kontakt: PropTypes.shape({
    EMAIL: PropTypes.string,
    TELEFON: PropTypes.string,
  }),
};

export default propTypes;
